import React from 'react'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import InputAdornment from '@material-ui/core/InputAdornment'

import { isLoggedIn, setUser } from '../services/auth'
export const generateAddContactSchema = (sendableCountries, contact) => {
  const countries = sendableCountries.map(c => {
    return {
      id: c.id,
      iconUrl: c.flagImgURL,
      value: c.id,
      text: `+${c.callingCode}`,
    }
  })

  return [
    {
      id: 'countryId',
      component: TextField,
      startAdornmentValues: countries,
      value: contact.country.id,
      componentProps: {
        select: true,
        label: 'Telefono',
        required: true,
        InputLabelProps: {
          shrink: true,
        },
        InputProps: {
          startAdornment: (
            <InputAdornment position="start">
              <img
                src={contact.country.flagImgURL}
                alt="country-flag"
                style={{ width: '100%', maxWidth: '50px' }}
              />
            </InputAdornment>
          ),
        },
        defaultValue: contact.country.id,
        style: { maxWidth: '100px', minWidth: '100px' },
      },
      children: countries.map(country => (
        <MenuItem key={country.id} value={country.value}>
          {country.text}
        </MenuItem>
      )),
    },
  ]
}

export const generateGroupedContacts = contacts => {
  return contacts.reduce(
    (grouped, contactResponse) => {
      grouped.contacts = [...grouped.contacts, ...contactResponse.contacts]
      grouped.groups = [...grouped.groups, contactResponse.id]
      grouped.groupCounts = [
        ...grouped.groupCounts,
        contactResponse.contacts.length,
      ]
      return grouped
    },
    {
      contacts: [],
      groups: [],
      groupCounts: [],
    },
  )
}

export const generateGUID = () => {
  return 'xxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const addVoucherToCart = (voucher, quantity) => {
  const voucherInput = {
    id: voucher.id,
    name: voucher.name || voucher.shortName,
    brand:
      voucher.partnerPushMoney.commercialName ||
      voucher.partnerPushMoney.legalName,
    amount: voucher.localAmount,
    localAmount: voucher.calculatedPrice,
    quantity,
    discountAmount: voucher.discountPrice ? voucher.discountPrice : 0,
  }

  return [voucherInput]
}

export const addFormattedVoucherToCart = voucher => {
  return [
    Object.keys(voucher).reduce((v, key) => {
      if (!['primaryImgURL'].includes(key)) {
        v[key] = voucher[key]
      }

      return v
    }, {}),
  ]
}

export const checkUserOrCreateAnonymousUser = async createAnonymousUser => {
  const isLogged = isLoggedIn()
  if (!isLogged) {
    const {
      data: { createAnonymousUser: user },
    } = await createAnonymousUser()
    setUser({ token: user.token, user: user.user })
  }
  return true
}

export const convertDate = date => {
  var newDate = ''
  if (date) {
    if (date.indexOf('T') > -1) {
      newDate = date.split('T')[0]
    } else {
      newDate = date.split(' ')[0]
    }
    return newDate || ''
  }
}

export const formatDateVouchers = date => {
  if (date) {
    const dateObj = date.split(' ')
    const dateObjT = dateObj[0].split('T')
    const dateObjComa = dateObjT[0].split(',')
    if (date.includes('-')) {
      const dateObj2 = dateObjComa[0].split('-')
      const fechaIphone = `${dateObj2[2]}/${dateObj2[1]}/${dateObj2[0]}`
      return fechaIphone
    } else {
      const fechaIphone = `${dateObjComa[0]}`
      return fechaIphone
    }
  } else {
    return ''
  }
}

export const formatDate = date => {
  try {
    date = date.split('-').join('/')
    const fecha = new Date(date)
    if (fecha) {
      const day = fecha.getDate() < 10 ? `0${fecha.getDate()}` : fecha.getDate()
      const month =
        fecha.getMonth() + 1 < 10
          ? `0${fecha.getMonth() + 1}`
          : fecha.getMonth() + 1
      const year = fecha.getFullYear()
      return `${day}/${month}/${year}`
    } else {
      let arrDate = ''
      const dateObj = date.split(' ')
      if (dateObj[0].split('-').length > 1) {
        arrDate = dateObj[0].split('-')
      } else if (dateObj[0].split('/').length > 1) {
        arrDate = dateObj[0].split('/')
      }
      const dateObj2 = arrDate
      const fechaIphone = `${dateObj2[2]}/${dateObj2[1]}/${dateObj2[0]}`
      return fechaIphone
    }
  } catch (error) {
    return ''
  }
}

export const formatDateForExpiration = date => {
  if (date) {
    const dateObj = date.split(' ')
    const dateObj2 = dateObj[0].split('-')
    const day = dateObj2[2].split('T')
    const meses = [
      'ene',
      'feb',
      'mar',
      'abr',
      'may',
      'jun',
      'jul',
      'ago',
      'sep',
      'oct',
      'nov',
      'dic',
    ]

    const monthName = meses[parseInt(dateObj2[1]) - 1]
    const fechaIphone = `${day[0]}/${monthName}/${dateObj2[0]}`
    return fechaIphone
  } else {
    return ''
  }
}

export const getIpPublic = async () => {
  try {
    const ipPublic = await fetchIpPublic()
    return ipPublic
  } catch (error) {
    console.error('Error al obtener la dirección IP pública:', error)
    return ''
  }
}

const fetchIpPublic = async () => {
  try {
    const response = await fetch('https://api64.ipify.org/?format=json', {
      method: 'GET',
      timeout: 5000,
    })
    if (!response.ok) {
      return ''
    }
    const data = await response.json()
    return data?.ip
  } catch (e) {
    return e
  }
}

export const diffInDays = date => {
  const diffDataTime = new Date().getTime() - new Date(date).getTime()
  // const diffDataTime = new Date("2023-02-06 10:00:00").getTime() - new Date("2023-02-02 10:00:00").getTime()
  return diffDataTime / (1000 * 60 * 60 * 24)
}

export const moneyMask = number => {
  let roundedNumber = parseFloat(number)
  if (!isNaN(parseFloat(roundedNumber)) && roundedNumber % 1 !== 0) {
    roundedNumber = roundedNumber?.toFixed(2)
  }
  try {
    if (/^\d+$/.test(roundedNumber)) {
      return ('' + Math.floor(roundedNumber)).replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ',',
      )
    } else {
      return roundedNumber
    }
  } catch (error) {
    return roundedNumber
  }
}

export const isValidNumber = variable => {
  if (variable === undefined || variable === null || variable === '') {
    return false
  }
  if (isNaN(variable)) {
    return false
  }
  return true
}

export const invalidFlags = [
  1,
  3,
  5,
  6,
  9,
  10,
  11,
  12,
  13,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  26,
]

export const formatDateIphone = date => {
  if (date) {
    const dateObj = date.split(' ')
    const dateObj2 = dateObj[0].split('-')
    const day = dateObj2[2].split('T')
    const meses = [
      'ene',
      'feb',
      'mar',
      'abr',
      'may',
      'jun',
      'jul',
      'ago',
      'sep',
      'oct',
      'nov',
      'dic',
    ]

    const monthName = meses[parseInt(dateObj2[1]) - 1]
    const fechaIphone = `${day[0]}/${monthName}/${dateObj2[0]}`
    return fechaIphone
  } else {
    return ''
  }
}

export const cleanPhoneNumber = phone => {
  return phone?.replace(/[^+\d]/g, '')
}
